/*
|--------------------------------------------------------------------------
| State
|--------------------------------------------------------------------------
*/

const state = {
    loadingVoucherCode: false,
    voucherCode: null,
    voucherCodeError: null,
};

/*
|--------------------------------------------------------------------------
| Actions
|--------------------------------------------------------------------------
*/

const actions = {
    getVoucherCodeDetails({ commit }, { code, clinic, callback }) {
        commit('setLoadingVoucherCode', true);

        const successCallback = (response) => {
            if (response.data.message) {
                commit('setVoucherCode', null);

                commit('setVoucherCodeError', response.data.message);

                commit('setLoadingVoucherCode', false);
            } else {
                const voucherCode = response.data.data;

                if (clinic.InsideM25) {
                    if (!voucherCode.discount_inside_m25) {
                        commit('setVoucherCode', null);

                        commit('setVoucherCodeError', 'This code is only for use outside of London.');

                        commit('setLoadingVoucherCode', false);

                        return;
                    }
                } else {
                    if (!voucherCode.discount_outside_m25) {
                        commit('setVoucherCode', null);

                        commit('setVoucherCodeError', 'This code is only for use within London.');

                        commit('setLoadingVoucherCode', false);

                        return;
                    }
                }

                commit('setVoucherCode', response.data.data);

                commit('setVoucherCodeError', null);

                commit('setLoadingVoucherCode', false);

                callback && callback();
            }
        };

        const errorCallback = () => {
            commit('setLoadingVoucherCode', false);
        };

        window.axios.get(`v1/voucher/${code}/${clinic.ClinicID}`).then(successCallback).catch(errorCallback);
    },

    clearVoucherCode({ commit }) {
        commit('setVoucherCode', null);
    },

    clearVoucherCodeError({ commit }) {
        commit('setVoucherCodeError', null);
    },
};

/*
|--------------------------------------------------------------------------
| Mutations
|--------------------------------------------------------------------------
*/

const mutations = {
    setLoadingVoucherCode(state, loading) {
        state.loadingVoucherCode = loading;
    },

    setVoucherCode(state, code) {
        state.voucherCode = null;

        if (code && code.ends_at) {
            code.ends_at = window.moment(code.ends_at);
        }

        state.voucherCode = code;
    },

    setVoucherCodeError(state, error) {
        state.voucherCodeError = error;
    },
};

/*
|--------------------------------------------------------------------------
| Export
|--------------------------------------------------------------------------
*/

export const voucher = {
    namespaced: true,
    actions,
    mutations,
    state,
};
